import { observer } from 'mobx-react-lite'
import RootStore from '../../store/RootStore'
import './styles/AppFooter.scss'

type Props = {}

const AppFooter = observer((props: Props) => {
  const place = localStorage.getItem('place')
  const socketId = RootStore.settingsStore.clientId
  const ip = RootStore.settingsStore.ip

  return (
    <div className="App-Footer">
      <div className="App-Footer-content">
        {place && (
          <>
            <div className="App-Footer-section">
              <h6>{place}</h6>
              <p>{socketId}</p>
            </div>
            <div className="App-Footer-section">
              <p>{ip}</p>
            </div>
          </>
        )}
      </div>
    </div>
  )
})
export default AppFooter
